import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/shared/ui/sheet";

import type { AcqFeedbackCode, AcqOpportunityCard } from "../../api/acqService";
import { sourceLabel } from "../../model/acqLabels";
import { AssignControl } from "./AssignControl";
import { OpportunityCard } from "./OpportunityCard";

/**
 * 线索详情抽屉 —— 表格负责扫,这里负责看。
 *
 * ★ 里面是**整张卡**(非 compact):事实、AI 推断、接手产物、五个反馈按钮一个不少。
 *   线索库改成表格之后,这些东西没有消失,只是从"每行都摊开"改成"要看才展开"。
 * ★ 抽屉里的动作(接手 / 补全 / 反馈 / 分派)走的是**同一套 `useAcqActions`**,
 *   patch 回来的卡同时更新表格那一行 —— 两处各记一份状态,必然出现
 *   "抽屉里已接手、关掉之后表上还写着还没动"。
 */
export function LeadDrawer({
  card,
  canAssign,
  meId,
  busy,
  unlockPrice,
  onOpenChange,
  onTake,
  onUnlock,
  onFeedback,
  onAction,
  onAssign,
  onClaim,
}: {
  card: AcqOpportunityCard | null;
  canAssign: boolean;
  meId: number | null;
  busy: boolean;
  unlockPrice: number | null;
  onOpenChange: (open: boolean) => void;
  onTake: (id: string) => void;
  onUnlock: (id: string) => void;
  onFeedback: (id: string, code: AcqFeedbackCode) => void;
  onAction: (card: AcqOpportunityCard) => void;
  onAssign: (id: string, assigneeId: number | null, displayName?: string) => void;
  onClaim: (id: string) => void;
}) {
  return (
    <Sheet open={!!card} onOpenChange={onOpenChange}>
      {/* ★ `sm:max-w-xl` 而不是默认的窄抽屉:里面是一张完整的商机卡,
          太窄的话事实那几行会挤成一个字一行。 */}
      <SheetContent className="w-full overflow-y-auto sm:max-w-xl">
        {card && (
          <>
            {/* ★★ 抽屉标题**只给读屏,不占版面**(`sr-only`):真渲染时抓到的 ——
                标题写一遍主体名与「公众号动态 · 浙江省宁波市」,紧接着卡头把同样两行
                又写了一遍,一屏里最显眼的位置摆了一份复读。
                但不能整个删掉:Radix 的 Dialog 没有 title 会掉无障碍(读屏打开抽屉时
                不知道自己进了哪一条)。 */}
            <SheetHeader className="sr-only">
              <SheetTitle>{card.subjectName}</SheetTitle>
              <SheetDescription>
                {sourceLabel(card.source)}
                {card.region ? ` · ${card.region}` : ""}
              </SheetDescription>
            </SheetHeader>
            <div className="mt-2">
              <OpportunityCard
                card={card}
                unlockPrice={unlockPrice}
                busy={busy}
                onTake={onTake}
                onUnlock={onUnlock}
                onFeedback={onFeedback}
                onAction={onAction}
                assignSlot={
                  <AssignControl
                    card={card}
                    canAssign={canAssign}
                    meId={meId}
                    busy={busy}
                    onAssign={onAssign}
                    onClaim={onClaim}
                  />
                }
              />
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
}
